import React from 'react'
import { Checkbox, Typography, Box } from '@mui/material'
import CheckIcon from '@mui/icons-material/Check'
import RemoveIcon from '@mui/icons-material/Remove'

const SelectAllCheckbox = ({ 
    allSelected, 
    noneSelected, 
    someSelected,
    onChange,
    label = "Select all"
}) => {
    const getCheckboxProps = () => {
        if (allSelected) {
            return {
                checked: true,
                indeterminate: false,
                icon: <Box sx={{ 
                    width: 16, 
                    height: 16, 
                    border: '2px solid #1F477D',
                    borderRadius: '3px',
                    backgroundColor: '#FFFFFF'
                }} />,
                checkedIcon: <Box sx={{ 
                    width: 16, 
                    height: 16, 
                    backgroundColor: '#1F477D', 
                    border: '2px solid #1F477D',
                    borderRadius: '3px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <CheckIcon sx={{ fontSize: 12, color: 'white' }} />
                </Box>
            }
        } else if (someSelected) {
            return {
                checked: false,
                indeterminate: true,
                icon: <Box sx={{ 
                    width: 16, 
                    height: 16, 
                    border: '1px solid #D1D5DB', 
                    borderRadius: '2px',
                    backgroundColor: '#FFFFFF'
                }} />,
                indeterminateIcon: <Box sx={{ 
                    width: 16, 
                    height: 16, 
                    backgroundColor: '#1F477D', 
                    border: '1px solid #1F477D', 
                    borderRadius: '2px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <RemoveIcon sx={{ fontSize: 13.5, color: 'white' }} />
                </Box>
            }
        } else {
            return {
                checked: false,
                indeterminate: false,
                icon: <Box sx={{ 
                    width: 16, 
                    height: 16, 
                    border: '2px solid #D1D5DB', 
                    borderRadius: '2px',
                    backgroundColor: '#FFFFFF'
                }} />,
                checkedIcon: <Box sx={{ 
                    width: 16, 
                    height: 16, 
                    backgroundColor: '#FFFFFF', 
                    border: '1px solid #D1D5DB',
                    borderRadius: '2px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <CheckIcon sx={{ fontSize: 12, color: 'white' }} />
                </Box>
            }
        }
    }

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 3, pl: 2.35 }}>
            {/* <Checkbox
                {...getCheckboxProps()}
                onChange={() => {
                    onChange()
                }}
                onClick={() => {
                    onChange()
                }}
                sx={{
                    padding: '0px',
                    '&:hover': {
                        backgroundColor: 'transparent',
                    },
                }}
            /> */}
            <Checkbox
                {...getCheckboxProps()}
                checked={allSelected}
                onChange={() => onChange()}
                onClick={onChange}
                sx={{
                    padding: '4px',
                    backgroundColor: '#FFFFFF',
                    '& .MuiSvgIcon-root': {
                        fontSize: 18,
                    },
                    '&:hover': {
                        backgroundColor: 'transparent',
                    },
                    '&.Mui-checked': {
                        backgroundColor: '#FFFFFF',
                    },
                    '&.MuiCheckbox-root': {
                        color: '#D1D5DB',
                        backgroundColor: '#FFFFFF',
                        '&.Mui-checked': {
                            color: '#1F477D',
                        },
                    }
                }}
            />
            <Typography 
                sx={{ 
                    fontSize: '14px',
                    fontWeight: 500,
                    color: '#374151',
                    ml: 1,
                }}
            >
                {label}
            </Typography>
        </Box>
    )
}

export default SelectAllCheckbox 